<template>
  <div class="inspection">
    <div class="nav">
      <div class="nav-left">
        <div class="parallelogram-btn-left" style="margin-right: 0.5vw" @click="toInInspection">
          <div class="icon-font">&#xe606;</div>
          <div>入库质检</div>
        </div>
        <div class="parallelogram-btn-left" @click="toOutInspection">
          <div class="icon-font">&#xe602;</div>
          <div>出库质检</div>
        </div>
      </div>
      <div class="nav-center">在库质检</div>
      <div class="nav-right">
        <div class="parallelogram-btn-right parallelogram-btn-active" style="margin-right: 0.5vw">
          <div class="icon-font">&#xe659;</div>
          <div>在库质检</div>
        </div>
        <div class="parallelogram-btn-right" @click="toHistoryInspection">
          <div class="icon-font">&#xe600;</div>
          <div>质检历史记录</div>
        </div>
      </div>
    </div>
    <transition name="enter-fade">
      <div class="inspection-cen">
        <div class="inspection-operation">
          <div class="two-font-wrapper" @click="toAddInspection"><div class="icon-font">&#xe605;</div>添加</div>
          <div class="four-font-wrapper" @click="deleteAll"><div class="icon-font">&#xe646;</div>批量删除</div>
          <div class="six-font-wrapper"><div class="icon-font">&#xe73d;</div>导入质检数据
            <input readonly="readonly" style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;opacity: 0" type="file" value="" id="file" @change="uploadConfig">
          </div>
          <div class="six-font-wrapper"><div class="icon-font">&#xe601;</div>导出质检数据
            <button readonly="readonly" style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;opacity: 0" @click="downloadConfig"/>
          </div>
          <div class="four-font-wrapper" @click="download"><div class="icon-font">&#xe621;</div>下载模板</div>
        </div>
        <div class="detail">
          <div class="detail-box">
            <div class="loading-data" v-if="loading">
              <i class="el-icon-loading"></i>
              <div>加载中，请稍后···</div>
            </div>
            <div class="detail-nav">
              <div class="detail-item" style="width: 5%">
                <div class="select-icon" :class="{'select-icon-active': all}" @click="selectAll"></div>
              </div>
              <div class="detail-item" style="width: 15%">物料代码</div>
              <div class="detail-item" style="width: 20%">位置</div>
              <div class="detail-item" style="width: 5%">重量</div>
              <div class="detail-item" style="width: 5%">水分</div>
              <div class="detail-item" style="width: 5%">霉变</div>
              <div class="detail-item" style="width: 5%">异味</div>
              <div class="detail-item" style="width: 5%">虫蛀</div>
              <div class="detail-item" style="width: 5%">杂物</div>
              <div class="detail-item" style="width: 5%">外观</div>
              <div class="detail-item" style="width: 5%">人工判定</div>
              <div class="detail-item" style="width: 5%">状态</div>
              <div class="detail-item" style="width: 15%">操作</div>
            </div>
            <div class="detail-content">
              <div class="detail-list-wrapper" v-if="!loading && tableData.length>0" v-for="(data,index) in tableData" :key="index">
                <div class="detail-item" style="width: 5%">
                  <div class="select-icon" :class="{'select-icon-active': data.sign === 1}" @click="selectSingle(data.id)"></div>
                </div>
                <div class="detail-item" style="width: 15%;" v-if="data.materialCode.length < 18">
                  {{data.materialCode}}
                </div>
                <div class="detail-item" style="width: 15%;display: block" v-if="data.materialCode.length >= 18">
                  <el-popover
                    placement="top"
                    title=""
                    trigger="hover"
                    :content="data.materialCode">
                    <div class="popover" slot="reference">{{data.materialCode}}</div>
                  </el-popover>
                </div>
                <div class="detail-item" style="width: 20%" v-if="data.siteName && data.siteName.length>=15">
                  <el-popover
                    placement="top"
                    title=""
                    trigger="hover"
                    :content="data.siteName">
                    <div class="popover" slot="reference">{{data.siteName || '--'}}</div>
                  </el-popover>
                </div>
                <div class="detail-item" style="width: 20%;display: block" v-if="data.siteName && data.siteName.length<15">{{data.siteName || '--'}}</div>
                <div class="detail-item" style="width: 20%;display: block" v-if="!data.siteName">{{data.siteName || '--'}}</div>
                <div class="detail-item" style="width: 5%" :class="{'color-red':data.qcWeight === 2}">{{data.qcWeight === 2 ? '不合格' : '合格'}}</div>
                <div class="detail-item" style="width: 5%" :class="{'color-red':data.qcMoisture === 2}">{{data.qcMoisture === 2 ? '不合格' : '合格'}}</div>
                <div class="detail-item" style="width: 5%" :class="{'color-red':data.qcMildew === 2}">{{data.qcMildew === 2 ? '不合格' : '合格'}}</div>
                <div class="detail-item" style="width: 5%" :class="{'color-red':data.qcOdor === 2}">{{data.qcOdor === 2 ? '不合格' : '合格'}}</div>
                <div class="detail-item" style="width: 5%" :class="{'color-red':data.qcMoth === 2}">{{data.qcMoth === 2 ? '不合格' : '合格'}}</div>
                <div class="detail-item" style="width: 5%" :class="{'color-red':data.qcSundries === 2}">{{data.qcSundries === 2 ? '不合格' : '合格'}}</div>
                <div class="detail-item" style="width: 5%" :class="{'color-red':data.qcExterior === 2}">{{data.qcExterior === 2 ? '不合格' : '合格'}}</div>
                <div class="detail-item" style="width: 5%" :class="{'color-red':data.qcArtificialJudgement === 2}">{{data.qcArtificialJudgement === 2 ? '不合格' : '合格'}}</div>
                <div class="detail-item" style="width: 5%">{{data.status === 1 ? '已处理' : data.status === 2 ?  '未处理' : '--'}}</div>
                <div class="detail-item" style="width: 15%">
                  <div class="detail-btn item-look" @click="toLookInspection(data.id)">查看</div>
                  <div class="detail-btn item-change" style="margin: 0 0.5vw" @click="toReportCard(data.id)">报告单</div>
                  <div class="detail-btn item-delete" @click="deleteSingle(data.id)">删除</div>
                </div>
              </div>
              <div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
            </div>
            <div class="page-wrapper" v-if="!loading && total > rows">
              <div class="page-wrapper-left">共{{total}}条数据，每页显示{{rows}}条，当前第{{page}}页</div>
              <div class="page-wrapper-right">
                <div class="page-btn" @click="firstPage">首页</div>
                <div class="page-btn" @click="previousPage">上一页</div>
                <div class="page-btn" @click="nextPage">下一页</div>
                <div class="page-btn" @click="lastPage">尾页</div>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div class="alert-box" v-if="show">
              <div class="alert-content">
                <div class="alert-content-title">删除提醒</div>
                <div class="alert-content-msg">是否确认删除选中数据?</div>
                <div class="alert-content-btn">
                  <div class="btn-cancel button" @click="cancelDelete">取消</div>
                  <div class="btn-confirm button" @click="confirmDelete">确认</div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="remind-box" v-if="showAlert">
        <div class="remind-content">
          <div class="remind-content-title">提醒</div>
          <div class="remind-content-msg">
            <div class="remind-content-msg-item" v-for="(data, index) in alertData" :key="index">{{data}}</div>
          </div>
          <div class="remind-content-btn">
            <div class="btn-confirm button" @click="confirmAlert">确认</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {batchImport, qualityTesting, delQualityTesting, bathDelQualityTesting, allList} from '../../../api/maintain'
import {renderTime} from '../../../tools/methods'
export default {
  name: 'AtInspection',
  data () {
    return {
      alertData: [],
      showAlert: false,
      show: false,
      all: false,
      id: '',
      type: 0,
      idList: [],
      loading: false,
      page: 1,
      rows: 9,
      total: '',
      tableData: [],
      tHeader: ['物料名称', '物料代码', '位置', '质检类型', '重量', '水分',
        '霉变', '异味', '虫蛀', '杂物', '外观', '人工判定', '状态', '创建时间'],
      filterVal: ['materialName', 'materialCode', 'siteName', 'qcType', 'qcWeight',
        'qcMoisture', 'qcMildew', 'qcOdor', 'qcMoth', 'qcSundries', 'qcExterior',
        'qcArtificialJudgement', 'status', 'createdTime']
    }
  },
  created () {
    this.handleSearch(1)
  },
  methods: {
    handleSearch: function (click) {
      if (click === 1) {
        this.page = 1
      }
      this.loading = true
      let body = {
        qcType: 2,
        page: this.page,
        rows: this.rows
      }
      qualityTesting(body).then(res => {
        console.log(res)
        res.data.rows && res.data.rows.map(item => {
          item.sign = 0
        })
        this.tableData = res.data.rows || []
        this.total = res.data.total
        this.loading = false
        this.all = false
        this.idList = []
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    confirmAlert: function () {
      this.showAlert = false
    },
    uploadConfig: function (e) {
      let formData = new FormData()
      formData.append('file', e.target.files[0])
      formData.append('qcType', 2)
      if (e.target.files[0].name.lastIndexOf('.xls') > 0 || e.target.files[0].name.lastIndexOf('.XLS') > 0) {
        batchImport(formData).then(res => {
          console.log(res)
          if (res.code === 711) {
            this.alertData = res.message.split('&')
            this.alertData.splice(this.alertData.length - 1, 1)
            this.showAlert = true
            e.target.value = ''
          } else {
            this.$message({
              message: '导入成功!',
              type: 'success',
              center: 'true',
              duration: '1000'
            })
            e.target.value = ''
            this.handleSearch(1)
          }
        }).catch(err => {
          console.log(err)
          e.target.value = ''
        })
      } else {
        this.$message({
          message: '文件格式不正确!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
    },
    downloadConfig: function () {
      allList().then(res => {
        console.log(res)
        const list = res.data.map(item => {
          return {
            materialName: item.materialName, // 物料名称
            materialCode: item.materialCode, // 物料代码
            siteName: item.siteName ? item.siteName : '--', // 位置
            qcType: item.qcType === '' ? '--' : item.qcType === 1 ? '入库' : item.qcType === 2 ? '在库' : '出库', // 质检类型
            qcWeight: item.qcWeight === 2 ? '不合格' : '合格', // 重量
            qcMoisture: item.qcMoisture === 2 ? '不合格' : '合格', // 水分
            qcMildew: item.qcMildew === 2 ? '不合格' : '合格', // 霉变
            qcOdor: item.qcOdor === 2 ? '不合格' : '合格', // 异味
            qcMoth: item.qcMoth === 2 ? '不合格' : '合格', // 虫蛀
            qcSundries: item.qcSundries === 2 ? '不合格' : '合格', // 杂物
            qcExterior: item.qcExterior === 2 ? '不合格' : '合格', // 外观
            qcArtificialJudgement: item.qcArtificialJudgement === 2 ? '不合格' : '合格', // 人工判定
            status: item.status === 1 ? '已处理' : item.status === 2 ? '未处理' : '--', // 状态
            createdTime: this.getTime(item.createdTime) // 创建时间
          }
        })
        // console.log(list)
        this.export2Excel(list)
      }).catch(err => {
        console.log(err)
      })
    },
    export2Excel: function (body) {
      require.ensure([], () => {
        const { exportJson } = require('../../../vendor/Export2Excel')
        const tHeader = this.tHeader
        const filterVal = this.filterVal
        const list = body
        const data = this.formatJson(filterVal, list)
        exportJson(tHeader, data, '在库质检数据')
        this.$message({
          message: '导出成功!',
          type: 'success',
          center: 'true',
          duration: 1000
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    getTime: function (time) {
      return renderTime(time)
    },
    download: function () {
      // let xhr = new XMLHttpRequest()
      // const downloadUrl = '/api/basic/material/materialDownload'
      // xhr.open('GET', downloadUrl, true)
      // xhr.addEventListener('progress', function (event) {
      //   // 响应头要有Content-Length
      //   if (event.lengthComputable) {
      //     let percentComplete = event.loaded / event.total
      //     console.log(percentComplete) // 最后输出1
      //   }
      // }, false)
      // xhr.send()
      // location.href = '/api/basic/material/materialDownload'
      location.href = '/api/maintain/qualityTesting/qualityTestingDownload'
    },
    toInInspection: function () {
      this.$router.push({
        path: '/quality',
        query: {
          index: '5'
        }
      })
    },
    toOutInspection: function () {
      this.$router.push({
        path: '/quality/outInspection',
        query: {
          index: '5'
        }
      })
    },
    toHistoryInspection: function () {
      this.$router.push({
        path: '/quality/historyInspection',
        query: {
          index: '5'
        }
      })
    },
    selectAll: function () {
      this.type = 1
      this.all = !this.all
      let idList = []
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1
          idList.push(data.id)
        })
        this.idList = idList
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0
          this.idList = []
        })
      }
    },
    selectSingle: function (id) {
      this.tableData.map((data, index) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1
          if (data.sign === 1) {
            this.idList.push(data.id)
          } else {
            let idList = []
            this.idList.map((item, index) => {
              if (item !== id) {
                idList.push(item)
              }
            })
            this.idList = idList
          }
          console.log(this.idList)
        }
      })
      this.all = this.idList.length === this.tableData.length
    },
    deleteSingle: function (id) {
      this.show = true
      this.id = id
      this.type = 0
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true
        this.type = 1
      } else {
        this.$message({
          message: '请选择要删除的数据!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
      console.log(this.idList)
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
      if (this.type === 0) {
        console.log(this.id)
        let body = {
          id: this.id
        }
        delQualityTesting(body).then(res => {
          console.log(res)
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.show = false
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      } else {
        console.log(this.idList)
        let body = {
          idArray: this.idList.join()
        }
        bathDelQualityTesting(body).then(res => {
          console.log(res)
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.show = false
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    toReportCard: function (id) {
      this.$router.push({
        path: '/quality/reportCard',
        query: {
          index: '5',
          qcType: 3,
          id: id
        }
      })
    },
    toLookInspection: function (id) {
      this.$router.push({
        path: '/quality/lookInspection',
        query: {
          index: '5',
          qcType: 3,
          id: id
        }
      })
    },
    toAddInspection: function () {
      this.$router.push({
        path: '/quality/addInspection',
        query: {
          index: '5',
          qcType: 3
        }
      })
    },
    firstPage: function () {
      console.log('首页')
      if (this.page === 1) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page = 1
        this.handleSearch()
      }
    },
    previousPage: function () {
      console.log('上一页')
      if (this.page < 2) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page--
        this.handleSearch()
      }
    },
    nextPage: function () {
      console.log('下一页')
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++
        this.handleSearch()
      } else {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
    },
    lastPage: function () {
      console.log('尾页')
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows)
        } else {
          this.page = parseInt(this.total / this.rows) + 1
        }
        this.handleSearch()
      }
    }
  }
}
</script>

<style scoped>
  @import "Quality.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/quality/AtInspection.vue